import { client } from '../utils/api-client'
import {
  ValidateCouponsResponse,
  AutoApplyDiscountsResponse,
  ApplyCouponsResponse,
} from '../types/coupon'

/**
 * Validates coupon codes against the current order subtotal
 * @param codes - Array of coupon codes to validate
 * @param orderSubtotal - Current order subtotal amount
 * @param customerId - Optional customer ID for customer-specific coupons
 */
export async function validateCoupons(
  codes: string[],
  orderSubtotal: number,
  customerId?: string,
): Promise<ValidateCouponsResponse> {
  const data = {
    codes,
    orderSubtotal,
    customerId,
  }

  return client('coupons/validate', {
    data,
    method: 'POST',
  })
}

/**
 * Fetches auto-apply discounts eligible for the current order
 * @param orderSubtotal - Current order subtotal amount
 * @param customerId - Optional customer ID for customer-specific auto-apply discounts
 */
export async function getAutoApplyDiscounts(
  orderSubtotal: number,
  customerId?: string,
): Promise<AutoApplyDiscountsResponse> {
  const params = new URLSearchParams({
    orderSubtotal: orderSubtotal.toString(),
  })

  if (customerId) {
    params.append('customerId', customerId)
  }

  return client(`coupons/auto-apply?${params.toString()}`)
}

/**
 * Applies coupon codes to an order
 * @param orderId - The order ID to apply coupons to
 * @param couponCodes - Array of coupon codes to apply
 */
export async function applyCouponsToOrder(
  orderId: string,
  couponCodes: string[],
): Promise<ApplyCouponsResponse> {
  const data = {
    couponCodes,
  }

  return client(`orders/${orderId}/coupons`, {
    data,
    method: 'PUT',
  })
}

